import { useContext } from "react"
import { Context } from "../Context"
import service from "../api/services"
import { BASE_URL, Pt_Lense } from "./defaultValues"
import constant from "./constant"
import { TPaymentDetail } from "../components/organisms/PaymentVoucher/interface"

export const getDropdownValue = (constant: any, ind: any) => {
    // generates data for dropdown prefilled 
    let temp: any = {
        "value": 0,
        "label": '',
    }
    constant.map((item: any) => {
        if (item.value === ind) {
            temp.value = item.value
            temp.label = item.label
        }
    })
    return temp
}
export const getUniqueObj = (data: any, id: string, compareId: string) => {
    let tempObj: any
    data && data.map((item: any) => {
        if (item[id] === compareId) {
            tempObj = item
        }
    })
    return tempObj
}
export const getDropdown = (response: [], name: string) => {
    // generate dropdown object from response object 
    let dropdown: any = []
    response && response.map((value: any) => {
        dropdown.push({
            "key": value.id,
            "value": value.id,
            "label": value[name],
        }
        )
    })
    return dropdown
}

export const handleNumber = (e: any) => {
    // validate number 
    const inputValue = e.target.value;
    const digitsOnly = inputValue.replace(/\D/g, '');
    if (digitsOnly.length <= 10) {
        return digitsOnly
    }
}

export const checkPermissionsInArray = (code: string) => {
    // check for permissions in Api for user
    const [userPermission, setUserPermission] = useContext<string[]>(Context);
    return userPermission?.includes(code)
};

export const findConstantLabel = (constant: { label: string, value: string | number }[], value: string | number) => {
    const name: any = constant.find((item: any) => item.value === value);
    return name ? name.label : 'Unknown';
}

const numberWithCommas = (number: number) => {
    return Number(number).toLocaleString('en-IN'); // Use 'en-IN' for the Indian numbering system
};

export const convertToCommaFormat = (value: string | number): string => {
    return numberWithCommas(Number(Number(value)?.toFixed(2))) || ''
}

export const generatePdf = async (id: string, share?: boolean) => {
    try {
        const response = await service.SalesCart.sharePdf(id, { share: true })
        // if (response.status === 200) {
        //     let path = response.data.data.path
        //     let fullPath = `${BASE_URL}${path}`
        //     let cleanPAth = fullPath.replace(/api\/\.\//, '')
        //     let fileName = cleanPAth.substring(cleanPAth.lastIndexOf("/") + 1)
        //     // window.open(`${cleanPAth}`, '_blank')

        //     setTimeout(() => {
        //         fetch(`${cleanPAth}`).then((response) => {
        //             response.blob().then((blob) => {

        //                 // Creating new object of PDF file
        //                 const fileURL =
        //                     window.URL.createObjectURL(blob);

        //                 // Setting various property values
        //                 let alink = document.createElement("a");
        //                 alink.href = fileURL;
        //                 alink.download = `${fileName}`;
        //                 alink.click();
        //             });
        //         });
        //     }, 2000);

        // }
    } catch (error) {
        console.log('error', error)
    }
}

export const sumTwoNumbers = (number1: number, number2: number) => {
    // ======= sum of two numbers
    let n1 = !Number.isNaN(number1) ? number1 : 0
    let n2 = !Number.isNaN(number2) ? number2 : 0
    let n3 = Number(n1) + Number(n2)
    return Number(n3?.toFixed(3));
}

export const isValidProductType = (productType: any) => {
    const validTypes = Pt_Lense
    return validTypes.includes(productType);
};

export const handleFileDownload = async (response: any) => {
    let path = response
    let fullPath = `${BASE_URL}${path}`
    let cleanPAth = fullPath.replace(/api\/\.\//, '')
    let fileName = cleanPAth.substring(cleanPAth.lastIndexOf("/") + 1)
    // window.open(`${cleanPAth}`, '_blank')

    setTimeout(() => {
        fetch(`${cleanPAth}`).then((response) => {
            response.blob().then((blob) => {

                // Creating new object of PDF file
                const fileURL = window.URL.createObjectURL(blob);

                // Setting various property values
                let alink = document.createElement("a");
                alink.href = fileURL;
                alink.download = `${fileName}`;
                alink.click();
            });
        });
    }, 2000);

}

export const handleDecimalInputChange = (handleInputChange:<K extends keyof TPaymentDetail>(
    name: K,
    value: TPaymentDetail[K]
  ) => void
  , value: number) => {
    const stringValue = value.toString();
    const regex = /^\d*\.?\d{0,2}$/;
    if (regex.test(stringValue) || stringValue === '') {
        handleInputChange("amount", parseFloat(stringValue));
    }
}

export const renderOptions = (
    options: any[],
    selectedValue: any,
    property: string,
    handleClick: (productId: any) => void,
    isPeriod?: boolean
) => {
    return options?.map((option: any, index: number) => {
        const isSelected = selectedValue === option[property];
        return (
            <p
                className={`glass-div cursor-pointer fw-700 fs-md-18 fs-12 my-auto ${isSelected ? 'glass-div-selected' : ''
                    }`}
                key={`glass${index}`}
                onClick={() => handleClick(option.product_id)}
            >
                {isPeriod ? getDropdownValue(constant.PERIOD_USE, option[property])?.label : option[property]}
            </p>
        );
    });
};
export const calculateEyeConditions = (tempEyeDetail: any) => {
    const {
        r_dv_sph,
        r_dv_cyl,
        r_dv_axis,
        r_dv_pd,
        r_add,
        r_nv_sph,
        r_nv_cyl,
        r_nv_axis,
        r_nv_pd,
        l_dv_sph,
        l_dv_cyl,
        l_dv_axis,
        l_dv_pd,
        l_add,
        l_nv_sph,
        l_nv_cyl,
        l_nv_axis,
        l_nv_pd,
    } = tempEyeDetail;

    const isRightEmpty = Boolean(
        r_dv_sph || r_dv_cyl || r_dv_axis || r_dv_pd || r_add ||
        r_nv_sph || r_nv_cyl || r_nv_axis || r_nv_pd
    );

    const isLeftEmpty = Boolean(
        l_dv_sph || l_dv_cyl || l_dv_axis || l_dv_pd || l_add ||
        l_nv_sph || l_nv_cyl || l_nv_axis || l_nv_pd
    );

    const isBothEqual =
        r_dv_sph === l_dv_sph &&
        r_dv_cyl === l_dv_cyl &&
        r_dv_axis === l_dv_axis &&
        r_dv_pd === l_dv_pd &&
        r_add === l_add &&
        r_nv_sph === l_nv_sph &&
        r_nv_cyl === l_nv_cyl &&
        r_nv_axis === l_nv_axis &&
        r_nv_pd === l_nv_pd;

    return { isRightEmpty, isLeftEmpty, isBothEqual };
};
export const determineEyeType = (tempEyeDetail: any) => {
    const { isRightEmpty, isLeftEmpty, isBothEqual } = calculateEyeConditions(tempEyeDetail);

    if (isBothEqual) {
        return { label: 'Both Eyes', value: constant.EYE_TYPE_CONTACT_LENS.BOTH_EYE };
    } else if (isRightEmpty && !isLeftEmpty) {
        return { label: 'Right Eyes', value: constant.EYE_TYPE_CONTACT_LENS.RIGHT_EYE };
    } else if (!isRightEmpty && isLeftEmpty) {
        return { label: 'Left Eyes', value: constant.EYE_TYPE_CONTACT_LENS.LEFT_EYE };
    } else if (!isRightEmpty && !isLeftEmpty) {
        return { label: 'Both Eyes', value: constant.EYE_TYPE_CONTACT_LENS.BOTH_EYE };
    } else if (isRightEmpty && isLeftEmpty) {
        return { label: 'Left Eyes', value: constant.EYE_TYPE_CONTACT_LENS.LEFT_EYE };
    }
};

export const calculateDeliveryDate = (estimatedDeliveryDays: number): string => {
    const currentDate = new Date();
    const deliveryDate = new Date(currentDate);

    deliveryDate.setDate(currentDate.getDate() + estimatedDeliveryDays || 0);

    return deliveryDate.toISOString().split("T")[0];
  };

// function to mobile number according to region
export const mobileLenByRegion=():10 | 8=>{

    // Retrieve region code from localStorage and convert it to a number
    const regionCode = Number(localStorage.getItem('store_region'));
    
    // Decide currency symbol based on the region code
    return regionCode === constant.STORE_REGION.KUWAIT ? 8 : 10;
}

// end

// function to know the store is kuwait region or not
export const isStoreKuwaitRegion = (): boolean => {
    // Retrieve region code from localStorage and convert it to a number
    const regionCode = Number(localStorage.getItem('store_region'))

    return regionCode === constant.STORE_REGION.KUWAIT
}
//end

// Returns the appropriate currency placeholder based on the store region
export const getCurrencyPlaceholder=():"Amount" =>{
    
    // Decide currency placeholder based on the region code
    return  'Amount' ;
}
//end

// function to change the payment detail
export const paymentDetailLabel=() => isStoreKuwaitRegion() ? "Bank/WAMD" : "UPI";

// end

// function to change the currency
export const currencySymbol=():"₹" | 'KWD' =>{
    
    // Decide currency symbol based on the region code
    return isStoreKuwaitRegion() ? 'KWD' : '₹';
}
// end

//function to find the country code of phone number
export const countryCode = (): "+91" | "+965" => {
    return isStoreKuwaitRegion()
      ? constant.COUNTRY_CODES[1]?.code as "+965"
      : constant.COUNTRY_CODES[0]?.code as "+91";
  };
//end

// function to change the currency
export const resolveTaxType=():"GST" | 'VAT' =>{
    
    // Decide currency symbol based on the region code
    return isStoreKuwaitRegion() ? 'VAT' : 'GST';
}
// end

// function to update the price according to region
export const priceTagFormatter = (rawPrice: number | string | undefined) => {

    if(!rawPrice) return `${currencySymbol()} 0`
    // Trim the price if it's a string, then convert it to a number
    const parsedPrice = Number(typeof rawPrice === 'string' ? rawPrice.trim() : rawPrice);
  
    // Ensure two decimal places and format with commas
    const formattedPrice = numberWithCommas(Number(parsedPrice.toFixed(isStoreKuwaitRegion() ? 3 : 2)));
  
    // Return formatted price with currency and suffix
    return <span className="notranslate">
        {`${currencySymbol()} ${formattedPrice}${isStoreKuwaitRegion() ? '' : "/-"}`}
    </span>
  };
  
// end

export const formatSignedDecimal=(value:string | null):string=> {
    if(!value) return '0';
    const num = parseFloat(value);
    const formatted = Math.abs(num).toFixed(2);
    return (num >= 0 ? '+' : '-') + formatted;
  };

//extract the param from url
export const getParams = (path: string) => {
    let urlParams = new URLSearchParams(location.search);
    let typeValue: any = urlParams?.get(path)
    return typeValue
}

export const formatLensValue=(value:string):string=> {
    if (typeof value === 'string') {
      const num = parseFloat(value);
      if (!isNaN(num)) {
        const formatted = num.toFixed(2);
        // Preserve the original sign if it was explicitly positive
        return value.trim().startsWith('+') ? `+${formatted}` : formatted;
      }
    }
    return  '0.00' ;
  }
  